module.exports = __webpack_public_path__ + "static/img/chahua@2x.57040260.png";